/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Alle akzeptieren",
      "Wir verwenden Cookies, um unsere Seite zu optimieren. Dazu gehören analytische und Werbe-Cookies. Weitere Informationen findest du in unserer <a p0>Cookie-Richtlinie</a>.",
      "Optionen verwalten",
      "Wie sieht's mit Cookies aus?",
      "Cookie-Richtlinie",
      "Cookies verwalten",
      "(opens in new window)",
      "Breadcrumbs",
      "Home",
      "Footer",
      "© {{current_year}} Bumble All Rights Reserved",
      "Create account",
      "Get the app",
      "Help",
      "Press",
      "Privacy",
      "Terms",
      "{{partner}} homepage",
      "Proudly part of Bumble Inc",
      "About",
      "Blog",
      "Careers",
      "General",
      "Facebook",
      "Follow",
      "Instagram",
      "Twitter",
      "If you ever feel uncomfortable, encounter harmful behaviour or simply need advice, we’ve got you. Explore our range of how-to guides for practical tips and support.",
      "{{partner}} Safety Centre homepage",
      "Safety first, second, and always.",
      "Willkommen im Safety Centre, Video ansehen",
      "More Guides",
      "Menü schließen",
      "Guides",
      "Vorherige Helplines ansehen",
      "Weitere Helplines ansehen",
      "Helplines",
      "Hauptbereich",
      "Menü",
      "Menü öffnen",
      "Tools",
      "Updates",
      "Take me back",
      "Try refreshing your browser or simply go back to our homepage.",
      "We’re sorry, we can’t seem to find the page you’re looking for.",
      "Still need help?",
      "Try a different search term or <a href=\"{{feedback_url}}\" class=\"link\">contact us</a>.",
      "Double-check your spelling",
      "Use generic words to get wider results",
      "Try a similar but different search term",
      "Don’t stop now. Here are a few tips:",
      "You might also find these useful:",
      "Sorry, we couldn’t find any results matching your search.",
      "Search results",
      "Search results for {{search_query}}",
      "Suche löschen",
      "How can we help?",
      "Suchen",
      "On Bumble there’s no place for bad vibes, offensive language or abuse here. We take any reports of harmful behaviour seriously and we investigate every single one.",
      "We want to protect you and our community. So, if someone makes you feel uncomfortable or unsafe do not hesitate to report it and we will take the necessary actions.",
      "Unsolicited or non-consensual sexual content is never OK. We want to protect you, so if someone sends you a potentially explicit photo, we’ll blur it first and let you know.",
      "A catfish is a person who uses a fake profile to pretend to be someone else. They do it to trick people online. If you need help, we got your back.",
      "Harassment can be sexual or non-sexual. If someone is harassing you on Bumble or in real life, do not hesitate to contact us.",
      "Got a date coming up? Nice! We’re here to help you stay safe: not only on Bumble, but in real life too. So, if you’re absolutely ready to meet up, let’s get you prepared.",
      "During Covid, staying in has been the new going out. Meeting up can be risky, so here’s everything you should consider before you go from Bumble to real life.",
      "Your first date should be fun. Sure, it might be awkward at first but it should never be unsafe. Here are some time tips to stay safe and focus on having fun.",
      "We know that getting started (or coming back after a break) can be overwhelming, but we’re here for you. Here are some things you can do to get settled in.",
      "It’s easy to feel drained or exhausted while dating. If you’ve got dating burnout, we promise you’re not alone.",
      "When someone breaks your trust, it can leave you feeling hurt and betrayed. We know it’s distressing, so we’re here to help.",
      "If you’re dealing with feelings of rejection, we’ve got a great list of things you should always remember.",
      "Bumble is a space to be yourself, feel safe and have fun. We want that for everyone in our community. So, here are our top tips to help you date safely.",
      "Getting verified lets you show potential matches you’re a real person. Find out how to get verified here. It should only take a few minutes.",
      "Dating scams are real, so you should always be careful about what you share. Here are some tips on how to stay alert and protect yourself from potential scams.",
      "Consent is always necessary before you try something intimate or sexual with someone else. It means you both clearly and voluntarily agree to participate in a certain activity together.",
      "We know that messaging someone for the first time can be daunting. We’ve got lots of tips you can use to make sure your chat gets off to a great start.",
      "Our online dating safety centre was developed to help you stay safe & in control throughout your dating journey on Bumble. See our guides, tools and helplines.",
      "Harmful Behaviour | Safety Centre - Bumble",
      "What Happens When I Report | Safety Centre - Bumble",
      "Harmful Behaviour: Receiving An Explicit Photo | Safety Centre - Bumble",
      "Harmful Behaviour: Fake Profiles - Catfishing | Safety Centre - Bumble",
      "Harmful Behaviour: I’m Being Harassed | Safety Centre - Bumble",
      "Meeting In Real Life | Safety Centre - Bumble",
      "Meeting In Real Life: Dating During Covid | Safety Centre - Bumble",
      "Meeting In Real Life: Staying Safe On The Date | Safety Centre - Bumble",
      "Mental Wellbeing | Safety Centre - Bumble",
      "Mental Wellbeing: What Is Dating Burnout & How To Overcome It | Safety Centre - Bumble",
      "Mental Wellbeing: When Someone Breaks My Trust | Safety Centre - Bumble",
      "Mental Wellbeing: How To Handle A Lack Of Matches Or Replies | Safety Centre - Bumble",
      "Safety Tips For Dating Safely | Safety Centre - Bumble",
      "Safety Tips: How Verification Works | Safety Centre - Bumble",
      "Safety Tips: How To Stay Alert & Safe From Scams | Safety Centre - Bumble",
      "Safety Tips: Asking For & Giving Consent | Safety Centre - Bumble",
      "Safety Tips: Starting A Chat The Right Way | Safety Centre - Bumble",
      "Online Dating Safety Centre | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "Bereich schließen",
      "close",
      "Show more",
      "We’ve designed these tools to help you stay safe and in control, throughout your dating journey. Find out how to manage your experience on Bumble.",
      "For more tips and expert info on dating trends, sexuality, singledom and more, check out our latest blog articles.",
      "Unser Sicherheitshandbuch",
      "Sprachauswahl"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tags",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
